import { format } from 'date-fns';
import { GC_BLANK_DEFAULT } from "./globalConstants";
import { NUMBER_STYLE } from "./fields";
import { BLANK_TIME } from "./fields/TimeField/validity";
import { BLANK_DATE } from "./fields/DateField/validity";

// combinators: https://gist.github.com/Avaq/1f0636ec5c8d6aed2e45
export const I = x => x; // identity: a Fn that returns its original argument
export const K = x => _ => x; // constant: creates a Fn that will always return x (no-op)

// isDefined :: Any -> Boolean
export const isDefined = x => x !== undefined && x !== null;

// isDefined :: Any -> Boolean
export const isNumber = value => isDefined(value) && !isNaN(Number(value));

// does NOT treat 0 as falsy
// isEmpty :: Any -> Boolean
export const isEmpty = value => String(value).trim() === '' || value === null || value === undefined || Array.isArray(value) && !value.length || typeof value === 'object' && !Object.keys(value).length || value === GC_BLANK_DEFAULT;

// ensures we're not counting "undefined" === "undefined" as a match
// isTrueStringMatch (Any, Any) -> Boolean
export const isTrueStringMatch = (str1, str2) => {
  return str1 && str2 && `${str1}` === `${str2}`;
};
export const isValidUrl = url => {
  try {
    new URL(url);
  } catch (e) {
    return false;
  }
  return true;
};
const legacyGuid = () => {
  var counter = 0;
  function calculate(src) {
    return hex_sha1(src);
  }
  function hex_sha1(src) {
    return binb2hex(core_sha1(str2binb(src), src.length * 8));
  }
  function sha1_ft(t, b, c, d) {
    if (t < 20) return b & c | ~b & d;
    if (t < 40) return b ^ c ^ d;
    if (t < 60) return b & c | b & d | c & d;
    return b ^ c ^ d;
  }
  function sha1_kt(t) {
    return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
  }
  function safe_add(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
  }
  function rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }
  function str2binb(str) {
    var bin = new Array();
    var mask = (1 << 8) - 1;
    for (var i = 0; i < str.length * 8; i += 8) {
      bin[i >> 5] |= (str.charCodeAt(i / 8) & mask) << 24 - i % 32;
    }
    return bin;
  }
  function binb2hex(binarray) {
    var str = new String('');
    var tab = new String('0123456789abcdef');
    for (var i = 0; i < binarray.length * 4; i++) {
      str += tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 + 4 & 0xf) + tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 & 0xf);
    }
    return str;
  }
  function core_sha1(x, len) {
    x[len >> 5] |= 0x80 << 24 - len % 32;
    x[(len + 64 >> 9 << 4) + 15] = len;
    var w = new Array(80),
      a = 1732584193;
    var b = -271733879,
      c = -1732584194;
    var d = 271733878,
      e = -1009589776;
    for (var i = 0; i < x.length; i += 16) {
      var olda = a,
        oldb = b;
      var oldc = c,
        oldd = d,
        olde = e;
      for (var j = 0; j < 80; j++) {
        if (j < 16) w[j] = x[i + j];else w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
        var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
        e = d;
        d = c;
        c = rol(b, 30);
        b = a;
        a = t;
      }
      a = safe_add(a, olda);
      b = safe_add(b, oldb);
      c = safe_add(c, oldc);
      d = safe_add(d, oldd);
      e = safe_add(e, olde);
    }
    return new Array(a, b, c, d, e);
  }
  var dt = new Date();
  var id1 = dt.getTime();
  var id2 = Math.random() * Number.MAX_VALUE;
  var id3 = 'www.gocanvas.com';
  return calculate(id1 + id3 + id2 + counter++).toUpperCase();
};
export const guid = legacyGuid;
export const guidNumber = () => `temp-${Math.floor(Math.random() * 1e12)}`;
export const matchByGuid = guid => entry => entry.guid == guid;
export const matchById = id => entry => entry.id == id;

// turn a string into a valid slug, usable in html5 ids
// slugify :: String -> String
export const slugify = string => String(string).trim().replace(/\W/g, '') // only word characters
.replace(/\s/g, '-') // turn spaces into slugs
.replace(/-+/g, '-') // only one dash allowed
.toLowerCase();
export const matchFormat = timeformat => {
  const match = {
    'h:i K': 'hh:mm a',
    'H:i': 'HH:mm',
    'H:i:S': 'HH:mm:ss',
    'i:S': 'mm:ss'
  };
  return match[timeformat] || 'hh:mm a';
};
export const getCurrentTime = timeformat => {
  const formattedTime = format(new Date(), matchFormat(timeformat));
  return formattedTime;
};
export const getFormatTime = ({
  time,
  timeformat
}) => {
  if (time === BLANK_TIME) {
    return time;
  }
  const matchTime = !time ? new Date() : new Date(time);
  const formattedTime = format(matchTime, matchFormat(timeformat));
  return formattedTime;
};
export const validateMinRange = (minimum = '', num = '') => {
  if (isNumber(minimum) && Number(num) < Number(minimum)) {
    return false;
  } else {
    return true;
  }
};
export const validateMaxRange = (maximum = '', num = '') => {
  if (isNumber(maximum) && Number(num) > Number(maximum)) {
    return false;
  } else {
    return true;
  }
};
export const whiteListedTypesForCalculation = ['Number', 'Rating', 'Decimal', 'Sum',
// 'Date',
// 'Time',
'Calculation'];

//TODO: Double check types
export const blackListedTypesForMirror = ['Photo', 'Static Image', 'Signature', 'Drawing', 'GPS', 'Link', 'Payment', 'Mirror'];
export const paymentDataToIncludeBlacklist = ['Photo', 'Static Image', 'Signature', 'Drawing', 'Payment', 'Checkbox'];
export const conditionEntryTypeWhiteList = [0, 1, 2, 3, 4, 5, 7, 8, 9, 12, 20, 21, 23];
export const keyFieldEligibleTypes = ['Text', 'Number', 'Dropdown', 'Date', 'Time', 'Barcode'];

// Given an entry, return a boolean if entry is eligible to become a keyfield
export const isEligibleKeyField = ({
  type,
  style
}) => keyFieldEligibleTypes.includes(type) && (type !== 'Number' || type === 'Number' && [NUMBER_STYLE].includes(style));
export const referenceDataEligibleTypes = ['Text', 'Static Text', 'Number', 'Barcode', 'Link', 'Rating'];
export const moreSettingsWhiteList = ['GPS', 'Photo', 'Checkbox', 'Barcode', 'Payment', 'Mirror', 'Calculation', 'Sum'];
export const whiteListedTypesForPaymentField = ['Sum', 'Calculation', 'Number'];
export const choiceTypes = ['Single Choice', 'Dropdown'];
export const dateTypes = ['Date', 'Time'];
export const invisibleFieldTypes = ['Sum', 'Multi Photo', 'Long Text'];
export const getOperationType = operation_type_id => {
  const operationTypes = {
    1: 'add',
    2: 'multiply',
    3: 'subtract',
    4: 'divide'
  };
  const operationType = operationTypes[operation_type_id] || 'unknown';
  return operationType;
};
export const getConditionName = ({
  original_type_id
}) => {
  const conditionNames = {
    0: 'equals',
    1: 'does not equal',
    2: 'is less than',
    3: 'is less than or equal to',
    4: 'is greater than',
    5: 'is greater than or equal to',
    6: 'contains',
    7: 'starts with',
    8: 'ends with',
    9: 'does not contain',
    10: 'does not start with',
    11: 'does not end with'
  };
  return conditionNames[original_type_id] || 'unknown';
};

/**
 *
 * @param {event} e
 */
export const disableBackspace = e => {
  const key = e.keyCode || e.charCode;
  if (key == 8 || key == 46) {
    e.preventDefault();
    e.stopPropagation();
  }
};
export const sanitizeInput = (text = '') => {
  const tagsToRemove = ['script', 'submit', 'style', 'textarea', 'noscript'];
  const removeTag = function (text, tag) {
    const openingTagToRemove = new RegExp(`<${tag}>`, 'g');
    const closingTagToRemove = new RegExp(`<\/${tag}>`, 'g');
    return text.replace(openingTagToRemove, '').replace(closingTagToRemove, '');
  };
  return tagsToRemove.reduce(removeTag, text);
};
export const preventDot = e => {
  var key = e.charCode ? e.charCode : e.keyCode;
  if (key == 46) {
    e.preventDefault();
  }
};
export const roundDecimals = (e, mask) => {
  var value = Number(e.target.value).toFixed(mask);
  return value;
};
export const checkNumberStyleForPaymentTotalField = ({
  type,
  style
}) => {
  if (type === 'Number') {
    if (style === 0 || style === 4) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};

// normalizes value for clientEntries
export const getValue = (type, value, mirror = false) => {
  if ((type === 'Time' || type === 'Date') && [BLANK_TIME, BLANK_DATE].includes(value)) {
    return '';
  }
  if (type === 'Multiple Choice' && (value === GC_BLANK_DEFAULT || value === '')) {
    return [];
  }
  if (value === GC_BLANK_DEFAULT) {
    return '';
  }
  if (type === 'Date' && mirror) {
    const date = value ? new Date(value) : new Date();
    return date.toLocaleDateString();
  }
  return value !== null && value !== undefined ? `${value}` : '';
};
export const getStaticLoopValue = (type, value, mirror = false) => {
  if (type === 'Photo') {
    if (value && value.length) {
      if (value.length > 1) {
        return 'Photos Captured';
      }
      return value[0].name;
    }
    return '';
  }
  if (type === 'Signature') {
    return value && String(value).length ? 'Signature Captured' : '';
  }
  return getValue(type, value, mirror);
};
export const orderByPosition = (first, second) => first.position - second.position;
const compareNumbers = (a, b) => a - b;
export const compose = (fn, ...rest) => rest.length === 0 ? fn || (x => x) : (...args) => fn(compose(...rest)(...args));
const numbersOnly = value => Number(String(value).replace(/[^.\d]/g, ''));
const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
export const clampValue = ({
  minimum = 0,
  maximum = Infinity,
  value,
  type
}) => {
  if (type == 'Rating' || type == 'Number') {
    const filteredValue = numbersOnly(value);
    if (minimum !== null && maximum !== null) {
      if (type === 'Rating') {
        return clamp(filteredValue, 1, 5);
      } else {
        return clamp(filteredValue, minimum, maximum);
      }
    }
    return filteredValue;
  }
  return value;
};
export const inRange = (first, second, test) => {
  const [start, end] = [first, second].sort(compareNumbers);
  if (end) {
    return test >= start && test <= end;
  }
  return test > start;
};
export const reIndex = (originalPosition, newPosition, entryPosition) => {
  const movedBack = originalPosition > newPosition;
  const effected = inRange(originalPosition, newPosition, entryPosition);
  // If the entry position is between the new and old indexes it needs
  // to be updated
  if (effected) {
    return movedBack ? entryPosition + 1 : entryPosition - 1;
  }
  return entryPosition;
};
export const convertBlankDefault = val => {
  if (isEmpty(val)) {
    val = '';
  }
  return String(val);
};
export const convertBlankDefaultToZero = val => {
  if (isEmpty(val)) {
    val = 0;
  }
  return parseFloat(val);
};
export const reIndexByMatch = (entries, test, newPosition, oldPosition) => {
  return entries.map(entry => {
    if (test(entry)) {
      return {
        ...entry,
        position: newPosition
      };
    } else {
      const position = reIndex(oldPosition, newPosition, entry.position);
      return {
        ...entry,
        position
      };
    }
  }).sort(orderByPosition);
};
export const sortBy = (group, type, accessor) => {
  const sortTypes = {
    asc: (a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    },
    desc: (a, b) => {
      if (a > b) {
        return -1;
      }
      if (a < b) {
        return 1;
      }
      return 0;
    }
  };
  return group.sort((entry1, entry2) => {
    return sortTypes[type](accessor(entry1), accessor(entry2));
  });
};
export const setKeyfield = (entry, index, keyField, rowGuid) => ({
  ...entry,
  touched: false,
  rowGuid,
  parentGuid: entry.guid,
  order: index,
  guid: guid(),
  keyfieldGuid: keyField.guid
});

// Creates a new loop screen row
export const createNewRow = entries => {
  const rowGuid = guid();
  const [keyField] = entries;
  const newRefSourceEntryGuids = {};

  // Prepare entries and store updated guids for dependent entries in an object
  const entriesWithKeyField = entries.map((entry, i) => {
    const {
      guid: oldGuid
    } = entry;
    const updatedEntry = setKeyfield(entry, i, keyField, rowGuid);
    const {
      guid,
      reference_data_id
    } = updatedEntry;
    if (reference_data_id) {
      newRefSourceEntryGuids[oldGuid] = guid;
    }
    return updatedEntry;
  });
  return {
    activeRowGuid: rowGuid,
    entries: entriesWithKeyField.map(entry => {
      const {
        dependent_entry,
        reference_data_id
      } = entry;
      if (reference_data_id && dependent_entry) {
        // Set the dependent entry guid to the updated dependent entry guid
        // Without this change, ref data won't work properly when adding a new table row
        return {
          ...entry,
          dependent_entry: {
            ...dependent_entry,
            // if there's a guid in the lookup, it's from this sheet, if not, it's external
            guid: newRefSourceEntryGuids[dependent_entry.guid] || dependent_entry.guid
          }
        };
      }
      return entry;
    })
  };
};
const LABELS_ABOVE_STYLE = 0;
const TABLE_PREPOP_STYLE = 2;

// Object -> Boolean
export const isPrePopTableSheet = ({
  style
}) => style === TABLE_PREPOP_STYLE;
export const isLabelsAboveTableSheet = ({
  style
}) => style === LABELS_ABOVE_STYLE;